import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { useGetNonAdminAccess } from "../../common/hooks/useGetNonAdminAccess";
import DeploymentHealthGridItem from "../data-hub/components/dashboard/DeploymentHealthGridItem";
import LiveViewPtControlGridItem from "../data-hub/components/dashboard/LiveViewPtControlGridItem";
import SensoryConfigurationGridItem from "../data-hub/components/dashboard/SensoryConfigurationGridItem";
import EventPageTitle from "./components/EventPageTitle";
import EventTableContainer from "./components/table/EventTableContainer";
import RecentActivitiesFilters from "./components/RecentActivitiesFilters";

const NON_ADMIN_COLUMN_COUNT = 6;
const ADMIN_COLUMN_COUNT = 4;

const RecentActivitiesPage = (): JSX.Element => {
  const { nonAdminView } = useGetNonAdminAccess();

  const sm = nonAdminView ? NON_ADMIN_COLUMN_COUNT : ADMIN_COLUMN_COUNT;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1em",
      }}
    >
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={sm}>
          <SensoryConfigurationGridItem />
        </Grid>
        <Grid item xs={12} sm={sm}>
          <DeploymentHealthGridItem />
        </Grid>
        <Grid item xs={12} sm={sm}>
          <LiveViewPtControlGridItem />
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <EventPageTitle title="Recent Activities" />
        </Grid>

        <RecentActivitiesFilters />
      </Grid>

      <EventTableContainer />
    </Box>
  );
};

export default RecentActivitiesPage;
